<template>
    <!-- 推广明细 -->
    <ZhaiHead></ZhaiHead>

    <div class="container-fluid zhu px-0">
        <div class="row shengse">
            <div class="dixian px-4 py-2 d-flex justify-content-between">
                <div class="promo-title" @click="goBack">
                    <i class="fa fa-bullhorn"></i>推广中心
                </div>
            </div>

            <div class="promo-body">
                <div class="seg-tabs">
                    <div class="seg-item" :class="{ active: activeTab === 'all' }" @click="changeTab('all')">全部</div>
                    <div class="seg-item" :class="{ active: activeTab === 'in' }" @click="changeTab('in')">收入</div>
                    <div class="seg-item" :class="{ active: activeTab === 'out' }" @click="changeTab('out')">支出</div>
                </div>

                <div class="page-scroll" ref="pageScroll">
                    <div class="promo-content">
                        <!-- Loading -->
                        <div v-if="loading" class="state-card">
                            <div class="state-title">加载中…</div>
                            <div class="state-sub">正在获取推广明细</div>
                        </div>

                        <!-- Error -->
                        <div v-else-if="errorMsg" class="state-card">
                            <div class="state-title">加载失败</div>
                            <div class="state-sub">{{ errorMsg }}</div>
                            <button class="state-btn" @click="fetchList()">重试</button>
                        </div>

                        <!-- Empty -->
                        <div v-else-if="list.length === 0" class="empty-wrap">
                            <div class="empty-icon"><i class="fa fa-file-text-o"></i></div>
                            <div class="empty-text">暂无内容</div>
                        </div>

                        <!-- List -->
                        <div v-else class="list-wrap">
                            <div class="list-item" v-for="item in list" :key="item.id">
                                <div class="li-top">
                                    <div class="li-top-left">
                    <span class="badge-io" :class="moneyClass(item)">
                      <span class="badge-yen">¥</span>
                    </span>

                                        <span class="io-text">{{ item.amount > 0 ? "收入" : "支出" }}</span>

                                        <span class="io-money" :class="moneyClass(item)">
                      {{ formatMoney(item.amount) }} 元
                    </span>
                                    </div>

                                    <div class="li-top-right">{{ item.time }}</div>
                                </div>

                                <div class="li-desc">
                                    <span class="desc-strong">{{ item.title }}</span>
                                    <span class="desc-tag" v-if="item.tags && item.tags.length">
                    <span class="tag" v-for="(t, idx) in item.tags" :key="idx"># {{ t }}</span>
                  </span>
                                </div>

                                <div class="li-meta">
                                    <div class="meta-line" v-if="item.orderAmount != null">
                                        <span class="meta-label">订单金额</span>
                                        <span class="meta-value">{{ Number(item.orderAmount).toFixed(2) }} 元</span>
                                    </div>

                                    <div class="meta-line" v-if="item.orderNo">
                                        <span class="meta-label">订单号</span>
                                        <span class="meta-value mono">{{ item.orderNo }}</span>
                                        <button class="copy-btn" @click="copyText(item.orderNo)">复制</button>
                                    </div>
                                </div>
                            </div>

                            <!-- Pager -->
                            <div class="pager-wrap" v-if="totalPages > 1">
                                <div class="pager">
                                    <button class="pager-btn" :disabled="page === 1 || pageChanging" @click="goPage(page - 1)">«</button>

                                    <button class="pager-btn" :class="{ active: page === 1 }" :disabled="pageChanging" @click="goPage(1)">
                                        1
                                    </button>

                                    <template v-if="totalPages >= 3">
                                        <template v-if="page > 1 && page < totalPages">
                                            <button class="pager-btn dots" disabled>…</button>
                                            <button class="pager-btn active" disabled>{{ page }}</button>
                                            <button class="pager-btn dots" disabled>…</button>
                                        </template>
                                        <template v-else>
                                            <button class="pager-btn dots" disabled>…</button>
                                        </template>
                                    </template>

                                    <button
                                            class="pager-btn"
                                            :class="{ active: page === totalPages }"
                                            :disabled="pageChanging"
                                            @click="goPage(totalPages)"
                                    >
                                        {{ totalPages }}
                                    </button>

                                    <button class="pager-btn" :disabled="page === totalPages || pageChanging" @click="goPage(page + 1)">»</button>
                                </div>

                                <div class="pager-loading" v-if="pageChanging">加载中…</div>
                            </div>
                        </div>
                    </div>

                    <div class="gray-gap"></div>
                </div>
            </div>
        </div>
    </div>

    <ZhaiFoot></ZhaiFoot>
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import { mapGetters } from "vuex";
    import http from "../utils/http.js";

    export default {
        name: "MPromotionDetails",
        components: { ZhaiHead, ZhaiFoot },

        data() {
            return {
                activeTab: "all",

                // 后端分页：当前页数据 + 总数
                list: [],
                total: 0,

                page: 1,
                pageSize: 6,

                loading: false,
                pageChanging: false,
                errorMsg: "",

                reqSeq: 0,
                currentUserId: null,
            };
        },

        computed: {
            ...mapGetters(["getUser"]),

            totalPages() {
                const t = Number(this.total || 0);
                const s = Number(this.pageSize || 15);
                return Math.max(1, Math.ceil(t / s));
            },
        },

        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        mounted() {
            const token = localStorage.getItem("token");
            if (!token) {
                this.$router.replace("/login");
                return;
            }

            this.currentUserId = this.resolveUserIdSafe();
            this.fetchList();
        },

        methods: {
            goBack() {
                if (window.history.length > 1) window.history.back();
                else window.location.href = "/Promotion";
            },

            // ====== ✅ 与 PC 一致：后端筛选参数 ======
            mapFlowForApi(frontTab) {
                const t = (frontTab || "all").toLowerCase();
                if (t === "in") return "in";
                if (t === "out") return "out";
                return "all";
            },

            // 手机端页面没有“直推/间推”切换，固定 all
            mapTabForApi() {
                return "all";
            },

            // ====== ✅ 与 PC 一致：类型优先后端 type，兜底 amount 正负 ======
            displayType(item) {
                if (!item) return "in";
                const t = String(item.type || "").toLowerCase();
                if (t === "in" || t === "out") return t;

                const a = Number(item.amount);
                if (!Number.isFinite(a)) return "in";
                return a < 0 ? "out" : "in";
            },

            // ====== ✅ 与 PC 一致：金额按 type 强制正负，避免“支出却显示+” ======
            displayAmount(item) {
                if (!item) return 0;
                let a = Number(item.amount);
                if (!Number.isFinite(a)) a = 0;

                const t = this.displayType(item);
                if (t === "out") return -Math.abs(a);
                return Math.abs(a);
            },

            // ====== ✅ 列表项标题：后端给 title 就用，否则兜底拼接（可选） ======
            displayTitle(item) {
                if (item && item.title) return item.title;

                const who = item && item.fromUser ? `直推客户 ${item.fromUser}` : "直推客户";
                const tags = Array.isArray(item && item.tags) ? item.tags : [];
                const product =
                    tags.find((t) => t && !["佣金", "直推", "间推", "收入", "支出"].includes(t)) || "";
                const prodText = product ? ` 购买 #${product}#` : "";
                const typeText = this.displayType(item) === "out" ? "支出" : "收入";
                return `${who}${prodText} ${typeText}`;
            },

            // ====== UI：你 template 里直接用 item.amount / item.title ======
            // 为了不改模板，这里在拿到数据后做一次“规范化”
            normalizeList(rawList) {
                const arr = Array.isArray(rawList) ? rawList : [];
                return arr.map((x) => {
                    const type = this.displayType(x);
                    const amount = this.displayAmount(x);
                    return {
                        ...x,
                        type,
                        amount, // ✅ 覆盖成规范的正负金额（不改 template）
                        title: x && x.title ? x.title : this.displayTitle(x),
                    };
                });
            },

            // ====== tab 切换 ======
            async changeTab(tab) {
                if (this.activeTab === tab) return;
                this.activeTab = tab;
                this.page = 1;
                this.scrollTop();
                await this.fetchList();
            },

            // ====== 分页 ======
            async goPage(p) {
                const pageNum = Number(p);
                if (!pageNum || pageNum < 1 || pageNum > this.totalPages) return;
                if (pageNum === this.page) return;
                if (this.pageChanging) return;

                this.pageChanging = true;
                this.page = pageNum;
                this.scrollTop();

                await this.fetchList(true);
                this.pageChanging = false;
            },

            scrollTop() {
                this.$nextTick(() => {
                    const el = this.$refs.pageScroll;
                    if (el) el.scrollTop = 0;
                });
            },

            // ====== ✅ 请求后端（核心：tab + flow + page + pageSize + userId） ======
            async fetchList(isPaging = false) {
                const seq = ++this.reqSeq;

                if (!isPaging) this.loading = true;
                this.errorMsg = "";

                try {
                    const params = {
                        tab: this.mapTabForApi(),                 // all/direct/indirect（这里固定 all）
                        flow: this.mapFlowForApi(this.activeTab), // all/in/out ✅
                        page: this.page,
                        pageSize: this.pageSize,
                    };
                    if (this.currentUserId) params.userId = this.currentUserId;

                    const res = await http.get("/platform/withdraw/promoDetail", params);
                    const json = res && res.data ? res.data : null;

                    // 丢弃过期响应
                    if (seq !== this.reqSeq) return;

                    if (!json || json.status !== 1) {
                        this.errorMsg = (json && json.msg) || "接口返回异常";
                        this.list = [];
                        this.total = 0;
                        return;
                    }

                    const d = json.data || {};
                    const rawList = Array.isArray(d.list) ? d.list : [];
                    this.list = this.normalizeList(rawList);
                    this.total = Number(d.total || 0);
                } catch (e) {
                    if (seq !== this.reqSeq) return;
                    this.errorMsg = e && e.message ? e.message : "网络错误";
                    this.list = [];
                    this.total = 0;
                } finally {
                    if (seq === this.reqSeq) this.loading = false;
                }
            },

            // ====== money 显示（模板用 item.amount，所以这里基于“规范化后的 amount”） ======
            formatMoney(val) {
                const num = Number(val || 0);
                const abs = Math.abs(num).toFixed(2);
                if (num > 0) return `+${abs}`;
                if (num < 0) return `-${abs}`;
                return "0.00";
            },

            moneyClass(item) {
                const a = Number(item && item.amount);
                if (!Number.isFinite(a)) return "in";
                return a >= 0 ? "in" : "out";
            },

            async copyText(text) {
                try {
                    if (navigator.clipboard && navigator.clipboard.writeText) {
                        await navigator.clipboard.writeText(String(text));
                    } else {
                        const input = document.createElement("input");
                        input.value = String(text);
                        document.body.appendChild(input);
                        input.select();
                        document.execCommand("copy");
                        document.body.removeChild(input);
                    }
                    window.alert("已复制");
                } catch (e) {
                    console.error(e);
                }
            },

            // ====== ✅ 与 PC 一致：安全取 userId ======
            resolveUserIdSafe() {
                const u = this.getUser || {};
                if (u && u.id) return u.id;

                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                return null;
            },
        },
    };
</script>


<style scoped>
    .fa { margin-right: 6px; }

    .zhu {
        margin-top: 80px;
        height: calc(100vh - 80px);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
    .shengse {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }

    .promo-title { cursor: pointer; user-select: none; }
    .promo-title:active { opacity: 0.7; }

    .promo-body {
        flex: 1;
        background: #efefef;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }

    .seg-tabs {
        margin: 14px 14px 0;
        border: 1px solid #d8d8d8;
        border-radius: 999px;
        height: 40px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        overflow: hidden;
        background: #fff;
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
    }
    .seg-item {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        color: #111;
        cursor: pointer;
        user-select: none;
    }
    .seg-item.active {
        background: #00c26f;
        color: #fff;
        font-weight: 800;
    }
    .seg-item:active { opacity: 0.85; }

    .page-scroll {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 14px;
    }
    .promo-content {
        background: transparent;
        padding: 14px 0 0;
    }

    .list-wrap { padding: 0 14px; }
    .list-item {
        background: #fff;
        border-radius: 16px;
        padding: 12px 12px 10px;
        margin-bottom: 12px;
        border: 1px solid #f1f1f1;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.04);
    }

    .li-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }
    .li-top-left {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
    }
    .li-top-right {
        font-size: 12px;
        color: #9aa0a6;
        flex-shrink: 0;
    }

    .badge-io {
        width: 18px;
        height: 18px;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }
    .badge-io.in { background: #ffecec; color: #ff4d4f; }
    .badge-io.out { background: #eef6ff; color: #1677ff; }
    .badge-yen { font-size: 12px; font-weight: 900; line-height: 1; }

    .io-text { font-size: 13px; color: #666; flex-shrink: 0; }

    .io-money {
        font-size: 16px;
        font-weight: 900;
        letter-spacing: 0.2px;
        white-space: nowrap;
    }
    .io-money.in { color:#00c26f; }
    .io-money.out { color:#ff4d4f; }

    .li-desc {
        margin-top: 10px;
        font-size: 14px;
        color: #111;
        line-height: 1.45;
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
    }
    .desc-strong { font-weight: 800; }
    .desc-tag { display: inline-flex; flex-wrap: wrap; gap: 6px; }
    .tag { font-size: 12px; color: #9aa0a6; }

    .li-meta {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px dashed #f0f0f0;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .meta-line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }
    .meta-label { font-size: 12px; color: #9aa0a6; flex-shrink: 0; }
    .meta-value {
        font-size: 12px;
        color: #6b7280;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
    }
    .mono {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        letter-spacing: 0.2px;
    }
    .copy-btn {
        border: 0;
        background: #f4f4f5;
        color: #333;
        font-size: 12px;
        padding: 5px 10px;
        border-radius: 10px;
        flex-shrink: 0;
        cursor: pointer;
    }
    .copy-btn:active { opacity: 0.75; }

    .state-card {
        margin: 0 14px;
        border-radius: 16px;
        background: #fff;
        padding: 18px 16px;
        border: 1px solid #f1f1f1;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.04);
    }
    .state-title { font-size: 16px; font-weight: 900; color: #111; }
    .state-sub { margin-top: 6px; font-size: 13px; color: #9aa0a6; }
    .state-btn {
        margin-top: 12px;
        border: 0;
        background: #00c26f;
        color: #fff;
        font-weight: 800;
        padding: 10px 12px;
        border-radius: 12px;
        cursor: pointer;
    }
    .state-btn:active { opacity: 0.85; }

    .empty-wrap {
        margin: 0 14px;
        border-radius: 16px;
        background: #fff;
        height: 52vh;
        min-height: 360px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #c9c9c9;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.04);
    }
    .empty-icon {
        width: 72px;
        height: 72px;
        border-radius: 16px;
        background: #f2f2f2;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 14px;
    }
    .empty-icon .fa { margin-right: 0; font-size: 34px; color: #d6d6d6; }
    .empty-text { font-size: 16px; }

    .pager-wrap {
        padding: 10px 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .pager {
        display: inline-flex;
        align-items: center;
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid #e6e6e6;
        background: #fff;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.04);
    }
    .pager-btn {
        min-width: 34px;
        height: 32px;
        padding: 0 10px;
        border: 0;
        border-right: 1px solid #e6e6e6;
        background: #fff;
        color: #333;
        font-size: 18px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }
    .pager-btn:last-child { border-right: 0; }
    .pager-btn:disabled { opacity: 0.45; cursor: not-allowed; }
    .pager-btn.active { color: #00c26f; font-weight: 900; background: #f3fff8; }
    .pager-btn.dots { cursor: default; font-weight: 700; }
    .pager-btn:active:not(:disabled):not(.dots) { opacity: 0.75; }
    .pager-loading { margin-top: 8px; font-size: 12px; color: #9aa0a9; }
</style>
